import { getOrgTree } from '@/api/httpList';
import filter from '@/api/filter';
import Resource from '@/components/commons/resource';
import sensitiveView from "./../components/sensitiveView";
// const userType = JSON.parse(localStorage.getItem('userType')).type
export default (vm, org,row) => {
  console.log(row);
  return [
    {
      labelWidth: 120,
      title: {
        label: '提现信息'
      },
      data: [
        {
          name: '业务员姓名',
          key: 'userName',
          value: '',
          type: 1,
          readonly: true
        },
        {
          name: '所属机构',
          key: 'orgName',
          value: '',
          type: 1,
          readonly: true
        },
        {
          name: '所属团队',
          key: 'groupName',
          value: '',
          type: 1,
          hidden: org != true ? false : true,
          readonly: true
        },
        {
          name: '机构等级',
          key: 'organizationLevel',
          value: '',
          type: 1,
          hidden: org == true ? false : true,
          readonly: true
        },
        {
          name: '可提现金额',
          key: 'availableAmount',
          value: '',
          type: 1,
          readonly: true
        },
        {
          name: '申请时间',
          key: 'requestTime',
          value: '',
          type: 1,
          readonly: true
        },

        {
          name: '申请金额',
          key: 'requestAmount',
          value: '',
          type: 1,
          readonly: true
        },
        {
          name: '打款日期',
          key: 'paymentTime',
          value: '',
          type: 1,
          hidden: false,
          readonly: true,
          render(h, params) {
            if (params.value) {
              return <span>{filter.filterTime(params.value, 'YYYY-MM-DD')}</span>;
            } else {
              params.hidden = true;
            }
          }
        },
        {
          name: '状态',
          key: 'status',
          value: '',
          type: 1,
          readonly: true,
          render(h, item) {
            let map = {
              '0':'申请中',
              '1':'提现成功',
              '2':'已驳回',
            };
            if (vm.$units.isOkBao()) {
              map = {
                '0':'待打款',
                '1':'提现成功',
                '2':'已驳回',
                '-1':'转账失败',
                '9':'银行处理中',
              };
            }
            return <span>{map[item.value]}</span>;
          }
        },
        {
          name: '快递公司',
          key: 'deliveryCompany',
          value: '',
          type: 1,
          readonly: true
        },
        {
          name: '快递单号',
          key: 'deliveryId',
          value: '',
          type: 1,
          readonly: true
        },
        {
          name: '交易流水号',
          key: 'transNo',
          value: '',
          hidden: true,
          type: 1,
          readonly: true
        },
      ]
    },
    {
      labelWidth: 120,
      title: {
        label: '银行账户信息'
      },
      data: [
        {
          name: '户主名称',
          key: 'userName',
          value: '',
          type: 1,
          readonly: true
        },
        {
          name: '证件类型',
          key: 'cardType',
          value: '',
          type: 1,
          readonly: true
        },
        {
          name: '证件号',
          key: 'idNo',
          value: '',
          type: 1,
          readonly: true,
          render(){
            return <sensitiveView arr={row} eye="eyeShow1" keyName="idNo"></sensitiveView>;
          }
        },
        {
          name: '银行预留手机号',
          key: 'mobile',
          value: '',
          type: 1,
          readonly: true,
          render(h, item) {
            return <sensitiveView arr={row} eye="eyeShow3" keyName="mobile"></sensitiveView>;
          }
        },
        {
          name: '开户银行',
          key: 'bank',
          value: '',
          type: 1,
          readonly: true
        },
        {
          name: '账号类型',
          key: 'type',
          value: '',
          type: 1,
          hidden: false,
          readonly: true,
          render(h, item) {
            const arr = ['对公', '对私'];
            if (item.value) {
              const value = +item.value - 1;
              return <span>{arr[value]}</span>;
            } else {
              item.hidden = true;
            }
          }
        },
        {
          name: '银行账号',
          key: 'cardNo',
          value: '',
          type: 1,
          readonly: true,
          render(h, item) {
            return <sensitiveView arr={row} eye="eyeShow2" keyName="cardNo"></sensitiveView>;
          }
        },
      ]
    },
    {
      id: 'txzl',
      labelWidth: 120,
      title: {
        label: '提现资料'
      },
      data: [
        {
          name: '发票',
          key: 'detail',
          value: '',
          type: -1,
          hidden: false,
          readonly: true,
          block: true,
          render(h, item) {
            if (item.value.length > 0) {
              const list = JSON.parse(decodeURIComponent(item.value));
              let urlList = list.map((item, index) => {
                return { path: item.path, fileName: item.fileName };
              });
              return <Resource urlList={urlList} width="120px" height="80px" />;
            }
          }
        },
        {
          name: '收据',
          key: 'receipt',
          value: '',
          type: -1,
          readonly: true,
          block: true,
          render(h, item) {
            let urlList = [{ path: item.value, fileName: '收据' }];
            return <Resource urlList={urlList} width="120px" height="80px" />;
          }
        }
      ]
    },
    {
      labelWidth: 120,
      title: {
        label: '备注'
      },
      data: [
        {
          block: true,
          key: 'remark',
          name: '',
          value: '',
          placeholder: '请输入备注',
          type: 1,
          className: 'beizhu',
          modelType: 'textarea'
        }
      ]
    }
  ];
};
